<template>
  <div class="ua-flag-standings">
    <template v-if="match.sportType === '橄榄球'">
      <div v-if="ruleType === '淘汰赛'">
        <PromotionChart :rounds="rounds" />
      </div>
      <div v-else-if="ruleType !== '自定义'">
        <div v-for="(item, i) in list" :key="i" class="group-block">
          <div class="group-header">
            <span class="group-name">{{ item.name || '小组' }}</span>
            <div class="header-metrics">
              <span class="m-col">赛</span>
              <span class="m-col m-wdl">胜/平/负</span>
              <span class="m-col m-rate">胜率</span>
              <span class="m-col m-pts">积分</span>
            </div>
          </div>
          <div class="header-line" />
          <div
            v-for="(teamScore, index) in item.value"
            :key="teamScore.id"
            class="team-card"
          >
            <div class="card-left">
              <span class="rank">{{ index + 1 }}</span>
              <img class="badge" :src="filterImage(teamScore.badge, 40, 40, 2)" alt="" />
              <span class="team-name overflow-text">{{ teamScore.teamAlias || teamScore.name }}</span>
            </div>
            <div class="card-metrics">
              <span class="m-col">{{ teamScore.totalRound }}</span>
              <span class="m-col m-wdl">{{ teamScore.winRound }}/{{ teamScore.tieRound }}/{{ teamScore.loseRound }}</span>
              <span class="m-col m-rate">{{ winRateText(teamScore) }}</span>
              <span class="m-col m-pts">{{ teamScore.totalScore }}</span>
            </div>
          </div>
        </div>
      </div>
      <div v-else class="hint">自定义阶段暂无数据展示</div>
    </template>
    <div v-else-if="loaded" class="hint">当前定制积分榜仅支持橄榄球赛事</div>
    <!-- <div class="match-note">赛事数据统计由组委会提供</div> -->
    <div v-if="stages.length > 1" class="stage-footer">
      <div class="stage-scroll">
        <div
          v-for="item in stages"
          :key="item.id"
          class="stage-item"
          :class="{ selected: item.id === currentRound }"
          @click="goRound(item)"
        >
          {{ item.stageName }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import PromotionChart from '@/views/match/components/PromotionChart2'
import { QNImageUtil } from '@/utils'
import { getBMTeamScores1, getBMStageGamesByBMMatchId, getBMMatchStageGameList } from '@/api/match'

export default {
  name: 'UaFlagStandingsPage',
  components: { PromotionChart },
  data() {
    return {
      matchId: null,
      match: {},
      teamScores: [],
      list: [],
      stages: [],
      currentRound: null,
      ruleType: '',
      rounds: [],
      loaded: false
    }
  },
  created() {
    this.matchId = this.$route.params.matchId || this.$route.query.matchId
    this.currentRound = this.$route.query.stageId || null
  },
  mounted() {
    if (!this.matchId) return
    this.getBMStageGamesByBMMatchId()
  },
  methods: {
    getBMStageGamesByBMMatchId() {
      getBMStageGamesByBMMatchId({ matchId: this.matchId }).then(res => {
        const data = res.data
        this.match = data.match || {}
        this.loaded = true
        const unionMatch = res.data.unionMatch
        const nameParts = (this.match.chineseName || '').split('_')
        document.title = (nameParts[1] || this.match.chineseName || '') + '-积分榜'
        const shareObj = {
          title: (nameParts[0] || '') + this.getPromotion(unionMatch.beginDate, unionMatch.endDate),
          abstract: (nameParts[1] || '') + '/积分榜',
          image: QNImageUtil.imageView(this.match.icon)
        }
        this.wxShare(shareObj)

        const stages = data.stages
        if (stages && stages.length > 0) {
          this.stages = stages
          if (this.currentRound) {
            this.ruleType = stages.find(item => item.id === this.currentRound)?.ruleType
          } else {
            this.currentRound = this.stages[0].id
            this.ruleType = this.stages[0].ruleType
          }
        } else {
          this.stages = [{ id: '', ruleType: '' }]
          this.ruleType = data.match.ruleType
        }

        if (['循环赛', '双循环'].includes(this.ruleType)) {
          this.getBMTeamScores()
        } else if (this.ruleType === '淘汰赛') {
          this.getBMMatchStageGameList()
        } else {
          this.getBMTeamScores()
        }
      })
    },
    getPromotion(createDate, endDate) {
      const startTime = new Date(createDate)
      const endTime = new Date(endDate)
      const currentTime = new Date()
      if (currentTime < startTime) return '-敬请期待'
      if (currentTime >= startTime && currentTime <= endTime) return '-激战正酣'
      return '-完美闭幕'
    },
    getBMTeamScores() {
      getBMTeamScores1({
        matchId: this.matchId,
        pageSize: 1000,
        stageId: this.currentRound
      }).then(res => {
        const data = res.data
        this.match = data.match || {}
        this.teamScores = data.teamScores || []
        const groups = []
        let groupName = ''
        const groupObject = {}
        for (let i = 0; i < this.teamScores.length; i++) {
          const score = this.teamScores[i]
          groupName = score.groupName
          if (groupObject[groupName]) {
            groupObject[groupName].push(score)
          } else {
            groupObject[groupName] = [score]
          }
        }
        if (data.groups && data.groups.length > 1) {
          const orderedGroupNames = data.groups.map(g => g.name)
          for (let j = 0; j < orderedGroupNames.length; j++) {
            groupName = orderedGroupNames[j]
            groups.push({
              name: groupName,
              value: groupObject[groupName],
              sportType: this.match.sportType
            })
          }
        } else {
          groups.push({
            name: groupName,
            value: groupObject[groupName],
            sportType: this.match.sportType
          })
        }
        this.list = groups
      })
    },
    getBMMatchStageGameList() {
      getBMMatchStageGameList({
        matchId: this.matchId,
        pageSize: 1000,
        stageId: this.currentRound
      }).then(res => {
        this.rounds = res.data.rounds
      })
    },
    goRound(obj) {
      this.currentRound = obj.id
      this.ruleType = obj.ruleType
      if (['循环赛', '双循环'].includes(this.ruleType)) {
        this.getBMTeamScores()
      } else if (this.ruleType === '淘汰赛') {
        this.getBMMatchStageGameList()
      }
    },
    winRateText(teamScore) {
      if (!teamScore.totalRound) return ''
      return ((teamScore.winRound / teamScore.totalRound) * 100).toFixed(0) + '%'
    },
    filterImage(img, w, h, mode) {
      return QNImageUtil.imageView(img, parseInt(2 * w, 10), parseInt(2 * h, 10), mode)
    }
  }
}
</script>

<style scoped lang="scss">
.overflow-text {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.ua-flag-standings {
  min-height: 100%;
  padding: 12px 16px 88px;
  box-sizing: border-box;
  background: #000;
  color: #fff;
}

.group-block {
  margin-bottom: 20px;
}

.group-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 4px 4px 8px;
  padding-right: 0px;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.6);
}

.group-name {
  flex-shrink: 0;
  margin-right: 12px;
}

.header-metrics,
.card-metrics {
  display: flex;
  align-items: center;
  flex-shrink: 0;
  text-align: center;
}

.m-col {
  flex: 0 0 28px;
  font-size: 12px;
  font-weight: normal;
}

.m-wdl {
  flex: 0 0 56px;
}

.m-rate {
  flex: 0 0 44px;
}

.m-pts {
  flex: 0 0 36px;
}

.header-line {
  height: 1px;
  background: rgba(255, 255, 255, 0.08);
  margin-bottom: 10px;
}

.team-card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 14px;
  margin-bottom: 10px;
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.08);
  box-sizing: border-box;
  padding-right: 0px;
}

.card-left {
  display: flex;
  align-items: center;
  min-width: 0;
  flex: 1;
  margin-right: 8px;
}

.rank {
  flex-shrink: 0;
  width: 22px;
  font-size: 16px;
  font-weight: 500;
  color: #fff;
}

.badge {
  flex-shrink: 0;
  width: 37px;
  height: 37px;
  border-radius: 50%;
  object-fit: cover;
  margin: 0 10px 0 6px;
}

.team-name {
  flex: 1;
  min-width: 0;
  font-size: 16px;
  font-weight: 500;
  color: #fff;
}

.card-metrics {
  color: #fff;
  font-size: 14px;
  font-weight: 500;
}

.hint {
  text-align: center;
  padding: 32px 16px;
  font-size: 14px;
  color: #b4b4bf;
}

.match-note {
  font-size: 12px;
  color: #6e6e78;
  text-align: center;
  padding: 16px 8px 8px;
}

.stage-footer {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 20;
  padding-bottom: env(safe-area-inset-bottom, 12px);
  background: #111;
  border-top: 1px solid rgba(255, 255, 255, 0.08);
}

.stage-scroll {
  display: flex;
  overflow-x: auto;
  white-space: nowrap;
  -webkit-overflow-scrolling: touch;

  &::-webkit-scrollbar {
    display: none;
  }
}

.stage-item {
  flex-shrink: 0;
  padding: 14px 18px;
  font-size: 14px;
  color: #b4b4bf;

  &.selected {
    color: #ff682c;
    font-weight: 600;
    box-shadow: inset 0 -3px 0 #ff682c;
  }
}
</style>
